import SettlementPaymentsModalField from "./SettlementPaymentsModalField";
import SettlementPaymentsTextField from "./SettlementPaymentsTextField";

const DIGITS_AND_DECIMAL = /^\d*\.?\d*$/;

export default function SettlementPaymentsAmountFields({ values, onChange }) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
      <SettlementPaymentsModalField
        label="Payment Amount *"
        renderValue={
          <SettlementPaymentsTextField
            fieldName="paymentAmount"
            fieldValue={values.paymentAmount}
            onChange={onChange}
            inputMode="decimal"
            pattern={DIGITS_AND_DECIMAL}
            startAdornment="$"
          />
        }
      />
      <SettlementPaymentsModalField
        label="Total Amount"
        renderValue={
          <SettlementPaymentsTextField
            fieldName="totalAmount"
            fieldValue={values.totalAmount}
            onChange={onChange}
            inputMode="decimal"
            pattern={DIGITS_AND_DECIMAL}
            startAdornment="$"
          />
        }
      />
      <SettlementPaymentsModalField
        label="Receivable Amount"
        renderValue={
          <SettlementPaymentsTextField
            fieldName="receivable"
            fieldValue={values.receivable}
            onChange={onChange}
            inputMode="decimal"
            pattern={DIGITS_AND_DECIMAL}
            startAdornment="$"
          />
        }
      />
    </div>
  );
}
